import React from 'react'
import { Collapse, DotLoading, List, Radio, Space } from 'antd-mobile-v5'
import { useIeListForExaminer, useIeStatementList } from '../../services/hooks'
import { Link } from 'react-router-dom'

import styles from './IeStatement.module.css'

const IeDetailContent = ({ ieId }) => {
  const { data, loading } = useIeStatementList(ieId)

  return loading ? (
    <DotLoading />
  ) : (
    <List
      header={
        <div className={styles.count}>
          <Collapse>
            <Collapse.Panel key="paid" title={`付款进度 ${data.paid}/${data.total}`}>
              {data.ieStatusItemList.map((item) => {
                if (!item.paid) {
                  return (
                    <List.Item>
                      <div>{`${item.userInfoDTO.englishName}（${item.userInfoDTO.memberNumber}）`}</div>
                    </List.Item>
                  )
                }
                return null
              })}
            </Collapse.Panel>
            <Collapse.Panel
              key="handwrittenSignatureCandidateUnderstanding"
              title={`IE 教练考试候选人了解声明书 ${data.handwrittenSignatureCandidateUnderstanding}/${data.total}`}
            >
              {data.ieStatusItemList.map((item) => {
                if (!item.handwrittenSignatureCandidateUnderstanding7) {
                  return (
                    <List.Item>
                      <div>{`${item.userInfoDTO.englishName}（${item.userInfoDTO.memberNumber}）`}</div>
                    </List.Item>
                  )
                }
                return null
              })}
            </Collapse.Panel>
            <Collapse.Panel
              key="handwrittenSignatureLiabilityAgreement"
              title={`责任免除和特别风险承担协议书 ${data.handwrittenSignatureLiabilityAgreement}/${data.total}`}
            >
              {data.ieStatusItemList.map((item) => {
                if (!item.handwrittenSignatureLiabilityAgreement) {
                  return (
                    <List.Item>
                      <div>{`${item.userInfoDTO.englishName}（${item.userInfoDTO.memberNumber}）`}</div>
                    </List.Item>
                  )
                }
                return null
              })}
            </Collapse.Panel>
          </Collapse>
        </div>
      }
    >
      {data.ieStatusItemList.map((item) => (
        <List.Item>
          <div>{`${item.userInfoDTO.englishName}（${item.userInfoDTO.memberNumber}）`}</div>
          <Space justify="between" block>
            <Radio
              style={{
                '--icon-size': '18px',
                '--font-size': '14px',
                '--gap': '6px',
              }}
              checked={item.handwrittenSignatureCandidateUnderstanding7}
            >
              IE 教练考试候选人了解声明书
            </Radio>
            <Link to={`/ie_statement?code=${item.code}`} className={styles.check}>
              查看
            </Link>
          </Space>
          <Space justify="between" block>
            <Radio
              style={{
                '--icon-size': '18px',
                '--font-size': '14px',
                '--gap': '6px',
              }}
              checked={item.handwrittenSignatureLiabilityAgreement}
            >
              责任免除和特别风险承担协议书
            </Radio>
            <Link to={`/ie_orientation?code=${item.code}`} className={styles.check}>
              查看
            </Link>
          </Space>
          <Space justify="between" block>
            <Radio
              style={{
                '--icon-size': '18px',
                '--font-size': '14px',
                '--gap': '6px',
              }}
              checked={item.paid}
            >
              已支付
            </Radio>
          </Space>
        </List.Item>
      ))}
    </List>
  )
}

const IeStatementList = () => {
  const { data: ieList } = useIeListForExaminer()

  if (!ieList) return null

  return (
    <>
      <Collapse>
        {ieList.map((ie, index) => (
          <Collapse.Panel key={index} title={`${ie.location} - ${ie.ieDate}`}>
            <IeDetailContent ieId={ie.id} />
          </Collapse.Panel>
        ))}
      </Collapse>
    </>
  )
}

export default IeStatementList
